/* eslint eqeqeq: 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import '../../../../../../Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css';
import '../../../../../../Assets/EnsembleStyles/ViewTenantDetails.css';
import '../../../../../../Assets/EnsembleStyles/EnsHome.css';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import { IndividualTenantDetailGetCall, PutNormalHoursAction, GetZonesListforTenant } from '../../../../../../action/tenantAction';


// Company Information
import ViewCompanyInformation from '../ViewTenant/ViewCompanyInformation';
import ViewAfterHours from '../ViewTenant/ViewAfterHours';
import ViewHoursOfOperation from '../ViewTenant/ViewHoursOfOperation';
import ViewFixedCharges from '../ViewTenant/ViewFixedHours';
import ViewUsageMeters from '../ViewTenant/ViewUsageMeters';
import ViewZones from '../ViewTenant/ViewZones';
import ViewEmployees from '../ViewTenant/ViewEmployees';

import EditCompanyInfo from '../EditTenant/EditCompanyInformation';
import EditAfterHours from '../EditTenant/EditAfterHours';
import EditNormalHours from '../EditTenant/EditNormalHours';
import '../../../../../../Assets/EnsembleStyles/NormalHours.css';



class ViewTenantDetails extends Component {

  //Initial Load of Component with the id
  componentWillMount() {

    let TenantID = this.props.userID || localStorage.getItem('userID');
    if (TenantID > 0) {
      this.props.IndividualTenantDetailGetCall(TenantID);
      this.props.GetZonesListforTenant(TenantID);
    }
    if (this.props.userID > 0) {
      localStorage.setItem("userID", this.props.userID);
    }
  }

  componentDidMount(){
    let StateVal = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
    this.setState({OnPremisesState:StateVal});
    }

    componentWillReceiveProps(nextProps){
      if (this.props != nextProps) {
          console.log('calllingg',nextProps.OnPremises);
          let StateVal = (nextProps.OnPremises !== undefined && nextProps.OnPremises !== null) ? nextProps.OnPremises : false;
          let Zones = nextProps.TenantZones_response === undefined ? "" : nextProps.TenantZones_response;
          this.setState({OnPremisesState:StateVal, assigned_zones:Zones});
      }
  }

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
      clicked: false,
      TenantID: undefined,
      Display: 'View',      // View or Edit or state
      Tenant_Data: this.props.getResponse,
      Company_Name: this.props.getResponse.tenantName,
      OnPremisesState : false,
      redirectHome: false,
      assigned_zones: this.props.TenantZones_response,
      selected_zoneid: 0,
      selected_zonename: ''
    };
    this.toggle = this.toggle.bind(this);
    this.modaltoggle = this.modaltoggle.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.Display = this.Display.bind(this);              // View or Edit or state 
    this.GoBack = this.GoBack.bind(this);
    this.SetSelectedZone = this.SetSelectedZone.bind(this);
  }

  SetSelectedZone(ZoneID){
    let ZoneName = this.state.assigned_zones !== undefined && this.state.assigned_zones !== null && this.state.assigned_zones.length ? this.state.assigned_zones.filter(x => x.zoneId === Number(ZoneID)) : '';
    this.setState({
      selected_zoneid: Number(ZoneID),
      selected_zonename: ZoneName !== '' && ZoneName[0] !== undefined ? ZoneName[0].zoneName : ''
    });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        Display: 'View'
      });
    }
  }

  modaltoggle() {
    this.setState({ modal: !this.state.modal });
  }

  handleClick() {
    this.setState({ redirect: true });
  }


  Display(val) {
    if (this.state.Display == 'View') {
      this.setState({ Display: 'Edit' });
    }
    else {
      this.setState({ Display: 'View' });

    }
  }

  GoBack(){
    this.setState({redirectHome: true});
  }

  render(getResponse, getAllZones,getLabels,OnPremises) {

    let PageTitle, CompanyInformation, AfterHours, ZonesTab, HoursofOperation, AssignedZones = [];   
    if (this.state.assigned_zones !== undefined && this.state.assigned_zones !== null && this.state.assigned_zones.length) {
      let ZonedList = this.state.assigned_zones.sort((a,b)=>{
        let nameA = a['zoneName'].toLowerCase();
        let nameB = b['zoneName'].toLowerCase();
        if(nameA < nameB){
            return -1;
        }
        if(nameA > nameB){
            return 1;
        }
        if(nameA === nameB){
            return 0;
        }
        return 0;
      });
      ZonedList !== undefined && ZonedList !== null && ZonedList.map(el => (
        AssignedZones.push(<option value={el.zoneId}>{el.zoneName}</option>)
      ));
    }

    CompanyInformation = (this.state.Display == 'View') ? <ViewCompanyInformation Display={this.Display} /> : <EditCompanyInfo Display={this.Display} /> //  Company Information
    HoursofOperation = (this.state.Display == 'View') ? <ViewHoursOfOperation Display={this.Display} TenantAssignedZones={AssignedZones} SetSelectedZone={this.SetSelectedZone} /> : <EditNormalHours Display={this.Display} TenantAssignedZones={AssignedZones} SelectedZoneId={this.state.selected_zoneid} SelectedZoneName={this.state.selected_zonename} />  // Hours of Operation
    let label = this.props.getLabels;

    //redirect to home page
    if(this.state.redirectHome){
      return <Redirect to={"/managetenant"} />
    }

    if (this.props.getResponse != undefined) {

      var data = this.props.getResponse;
      PageTitle = data.tenantName;


      // After Hours View function

      if (this.state.Display == 'View') {
        // View Form of After Hours
        AfterHours = <ViewAfterHours parentToChildData={[data.ratePerHour, data.minmumAfterHour, data.rounderHours]} Display={this.Display} />
      }
      else {
        // Edit Form of After Hours
        AfterHours = <EditAfterHours parentToChildData={[data.ratePerHour, data.minmumAfterHour, data.rounderHours, data.tenantId]} Display={this.Display} />
      }
      ZonesTab = <ViewZones parentToChildData={[data.zones, this.props.getAllZones.ZonesList]} Display={this.Display} />

      return (
        <div>
            <p className="back_link_navigate" onClick={this.GoBack}>{"<"}&ensp;{"Back"}</p>
            <h4 className="tab_title" style={{padding:"15px 20px 5px 20px"}}>{PageTitle}</h4>
            <Nav tabs style={{'border-bottom':'0px'}} >
              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '1' }, "Tab_header_link","link_cursor","header_tab")} onClick={() => { this.toggle('1'); }}>{label['TabbedView.CompanyInfo.Text']}</NavLink>
              </NavItem>

              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '2' }, "Tab_header_link","link_cursor","header_tab")} onClick={() => { this.toggle('2'); }} >{label['TabbedView.Zones.Text'] !== undefined ? label['TabbedView.Zones.Text'] : "Zones"}</NavLink>
              </NavItem>

              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '3' }, "Tab_header_link","link_cursor","header_tab")} onClick={() => { this.toggle('3'); }} >{label['TabbedView.AfterHours.Text'] !== undefined ? label['TabbedView.AfterHours.Text']: "After-Hours Requests"}</NavLink>
              </NavItem>

              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '4' }, "Tab_header_link","link_cursor","header_tab")} onClick={() => { this.toggle('4'); }} >{label['TabbedView.NormalHours.Text']}</NavLink>
              </NavItem>

              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '5' }, "Tab_header_link","link_cursor","header_tab")} onClick={() => { this.toggle('5'); }} >{label['TabbedView.Occupants.Text']}</NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '6' }, "Tab_header_link","link_cursor","header_tab")} onClick={() => { this.toggle('6'); }} >{label['TenantConsumption.UsageMeters.Text'] !== undefined ? label['TenantConsumption.UsageMeters.Text']  : "Usage Meters"}</NavLink>
              </NavItem>

              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '7' }, "Tab_header_link","link_cursor","header_tab")} onClick={() => { this.toggle('7'); }} >{label['CreateTenant.FixedRateSetup.Text'] !== undefined ? label['CreateTenant.FixedRateSetup.Text'] : "Fixed Charges"}</NavLink>
              </NavItem>
            </Nav>



          <div className="tenant_tab_border" style={{height:'100%'}}>
            <TabContent activeTab={this.state.activeTab} className={this.state.OnPremisesState ? "OnPrimise_active_Content" : ""}>

              {/* Company Information */}

              <TabPane tabId="1" className="tenant_content_border">  <Row> <Col sm="12"> <div className="main_container"> {CompanyInformation}  </div> </Col> </Row>  </TabPane>


              {/* Zones */}

              <TabPane tabId="2" className="tenant_content_border"> <Row> <Col sm="12"> {ZonesTab} </Col> </Row> </TabPane>


              {/* AfterHours */}

              <TabPane tabId="3" className="tenant_content_border">
                <Row><Col sm="12">{AfterHours}</Col></Row>
              </TabPane>


              {/* Hours of operation */}

              <TabPane tabId="4" className="tenant_content_border">
                <Row> <Col sm="12"> <div className="main_container"> {HoursofOperation}</div> </Col> </Row>
              </TabPane>


              {/* Employees */}

              <TabPane tabId="5" className="tenant_content_border" > <Row> <Col sm="12"> <ViewEmployees /> </Col> </Row> </TabPane>


              {/* Usage Meters */}
              <TabPane tabId="6" className="tenant_content_border"> <Row> <Col sm="12"><ViewUsageMeters /> </Col> </Row></TabPane>

              {/* Fixed Charges */}
              <TabPane tabId="7" className="tenant_content_border"><Row><Col sm="12"> <ViewFixedCharges />  </Col>  </Row> </TabPane>

            </TabContent>
          </div>
        </div>

      );
    }
    else {
      return (
        <p>{label['LoadingData.Text']}</p>
      );
    }
  }
}



const mapStateToProps = state => {

  return {
    userID: state.tenantsRootReducer.TenantToDisplay.userID,
    getResponse: state.ViewtenantsRootReducer.TenantDetails,
    userData: state.tenantsRootReducer.userDetails,
    getAllZones: state.zonesRootReducer,
    getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
    OnPremises: state.authService.IsOnPremise,
    TenantZones_response: state.ViewtenantsRootReducer.TenantZones
    //userData: state.tenantsRootReducer.userDetails
  };
};

const mapDispatchToProps = dispatch => {
  return {
    IndividualTenantDetailGetCall: (id) => dispatch(IndividualTenantDetailGetCall(id)),
    GetZonesListforTenant: (id) => dispatch(GetZonesListforTenant(id)),
    PutNormalHoursAction: (normalhours) => dispatch(PutNormalHoursAction(normalhours))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewTenantDetails);




